import alert from '../modules/Popup';
import {createElement} from "../util/utils";

const { __ } = wp.i18n;

export default class ProductCompare {

  constructor()
  {
    if(ProductCompare.exists) {
      return ProductCompare.instance;
    }
    ProductCompare.instance = this;
    ProductCompare.exists = true;

    this.storageKey = `compare_${palram.compare_id}`;
    this.products = this.getProducts();
    this.compareLink = palram.compare_url;
    this.limit = 4;
    this.panel = null;
    this.panelWrapper = null;
    this.compareText = [__('Compare', 'canopia'), __('Compare now', 'canopia')];
    //this.onBodyClick = this.onBodyClick.bind(this);

    this.addHandlers();
    this.updateButtons();
  }

  addHandlers()
  {
    document.body.addEventListener('click', event => {
      let button = this.isCompareButton(event.target);

      if(!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if('true' === event.target.dataset.open) {
        this.openPanel();
        return;
      }

      let id = button.dataset.productId;

      if( undefined === id) {
        return;
      }

      id = parseInt(id);

      let inCompare = this.isInCompare(id);
      let success = true;

      if(inCompare) {
        this.remove(id);
      } else {
        const data = {
          id,
          image: this.getImageSrc(button),
        };
        success = this.add(data);

        if(success) {
          this.insertInPanel(data)
          this.openPanel();
          this.updateButton(button, true);
        }
      }

    });
    document.body.addEventListener('compare_removed', this.onCompareRemoved.bind(this));
    document.body.addEventListener('products_loaded', this.onProductsLoaded.bind(this));
  }

  getIds()
  {
    return !this.products || this.products.length === 0 ? [] : this.products.map(item => parseInt(item.id));
  }

  getProducts()
  {
    let products = localStorage.getItem(this.storageKey);

    if(!products) {
      return [];
    }

    try {
      return JSON.parse(products);
    } catch (e) {
      this.clear();
      return [];
    }
  };

  getCount()
  {
    return this.products.length;
  }

  isInCompare(id)
  {
    return this.products.findIndex(element => element.id === parseInt(id)) > -1;
  }

  clear()
  {
    localStorage.removeItem(this.storageKey);
  }

  add(data) {
    if(!data.id) {
      return false;
    }

    if(this.isInCompare(data.id)) {
      return true;
    }
    if( this.getCount() >= this.limit ) {
      this.error(__(`You can\'t add more than ${this.limit} products`, 'canopia'));
      this.openPanel();
      return false;
    }
    this.products.push(data);
    this.save();
    return true;
  }

  remove(id)
  {
    const index = this.products.findIndex(element => element.id === parseInt(id));
    if (index > -1) {
      this.products.splice(index, 1);
      document.body.dispatchEvent( new CustomEvent('compare_removed', {
        bubbles: false,
        detail: {
          id
        },
      }));
      this.save();
    }
  }

  save()
  {
    try {
      //Check for duplicated values
      this.products = this.products.filter((elem, pos, arr) => {
        return arr.indexOf(elem) === pos;
      });
      localStorage.setItem(this.storageKey, JSON.stringify(this.products));
      // document.body.dispatchEvent( new CustomEvent('compare_updated', {
      //   bubbles: false,
      // }));
      if(this.getCount() > 1) {
        this.showCompareLink();
      } else {
        this.hideCompareLink();
      }
    } catch (e) {
      this.error(__('Product not added', 'canopia'));
    }
  }

  error(message)
  {
    alert.open({
      title: __('Oh no...', 'canopia'),
      type: 'warning',
      message: `<p>${message}</p>`,
      close: {
        text: __('Try again', 'canopia'),
      }
    });
  }

  isCompareButton(elem)
  {
    if(elem === document) {
      return false;
    }
    if( elem.classList.contains( 'btn-compare' ) ) {
      return elem;
    }
    return elem.parentNode && this.isCompareButton( elem.parentNode );
  }

  getImageSrc(button)
  {
    try {
      let wrapper = button.closest('.product');
      let img = wrapper.querySelector('.attachment-product-thumbnail');
      return img.getAttribute('src');
    } catch (e) {
      return '';
    }
  }

  updateButton(button, inCompare)
  {
    if(!button) {
      return;
    }
    const compareText = button.querySelector('.compare-text');
    if(inCompare) {
      if(!button.classList.contains('active')) {
        button.classList.add('active');
      }
      compareText.dataset.open = 'true';
      compareText.textContent = this.compareText[1];
    } else {
      button.classList.remove('active');
      compareText.dataset.open = 'false';
      compareText.textContent = this.compareText[0];
    }
  }

  updateButtons(buttons)
  {
    if( ! buttons ) {
      buttons = document.querySelectorAll('.btn-compare');
    }

    if( !buttons || buttons.length === 0 ) {
      return;
    }

    buttons.forEach(button => {
      let id = button.dataset.productId;
      if(!id) {
        return;
      }
      this.updateButton(button, this.isInCompare(id));
    });
  }

  createPanel()
  {
   if(this.panel) {
     return this.panel;
   }

   let panel = createElement({
     classes: ['compare-panel'],
     parent: document.body,
   });

   createElement({
     classes: ['compare-title'],
     textContent: __('Select 2 to 4 Items to Compare', 'canopia'),
     parent: panel,
   });

   this.panelWrapper = createElement({
     classes: ['compare-items'],
     parent: panel
   });

   if(this.compareLink) {
     const button = createElement({
       tagname: 'a',
       classes: ['btn','btn-yellow-green','btn-compare-link'],
       attributes: {
         href: this.compareLink,
         style: 'display: none;',
       },
       textContent: __('Compare', 'canopia'),
       parent: panel,
     });

     if(Array.isArray(this.products) && this.products.length > 1) {
       button.removeAttribute('style');
     }
   }

   if(Array.isArray(this.products) && this.products.length > 0) {
     if(this.products.length > 4) {
       this.product = this.products.splice(3, this.products.length - 4);
     }
     this.products.forEach(item => this.insertInPanel(item));
   }

   return panel;
  }

  insertInPanel(data)
  {
    if(!this.panelWrapper) {
      return;
    }
    let item = createElement({
      classes: ['compare-item'],
      attributes: {
        id: `compare-item-${data.id}`,
      },
      parent: this.panelWrapper,
    })

    createElement({
      tagname: 'img',
      attributes: {
        src: data.image,
      },
      parent: item,
    });

    let remove = createElement({
      tagname: 'button',
      classes: ['btn-close', 'btn-close-light'],
      attributes: {
        type: 'button',
        ariaLabel: __('Close', 'canopia'),
      },
      dataset: {
        productId: data.id,
      },
      parent: item,
    });
    remove.addEventListener('click', this.onRemoveButtonClick.bind(this));
  }

  showCompareLink()
  {
    if(!this.panel) {
      return;
    }

    const button = this.panel.querySelector('.btn-compare-link');

    if(!button) {
      return;
    }

    button.removeAttribute('style');
  }

  hideCompareLink()
  {
    if(!this.panel) {
      return;
    }

    const button = this.panel.querySelector('.btn-compare-link');

    if(!button) {
      return;
    }

    button.style.display = 'none';
  }

  openPanel()
  {
    if(!this.panel) {
      this.panel = this.createPanel();
    }
    this.panel.classList.toggle('open', true);
  }

  closePanel()
  {
    if(!this.panel) {
      return;
    }

    this.panel.classList.toggle('open', false);
  }

  onRemoveButtonClick(event)
  {
    let id = event.target.dataset.productId;

    if(id) {
      this.remove(id);
    }
  }

  onCompareRemoved(event)
  {

    let id = event.detail.id;
    //Update button
    const button = document.querySelector(`.btn-compare[data-product-id="${id}"]`);
    if(button) {
      this.updateButton(button, false);
    }

    if(!this.panelWrapper) {
      return;
    }

    let item = this.panelWrapper.querySelector(`#compare-item-${id}`);
    if(!item) {
      return;
    }

    item.remove();

    if(this.products && this.products.length === 0) {
      this.closePanel();
    }
  }

  onProductsLoaded(event) {
    const products = event.detail.products;
    if(undefined === products) {
      this.updateButtons();
    } else {
      let buttons = [];
      products.forEach(product => {
        buttons.push(product.querySelector('.btn-compare'));
      });
      this.updateButtons(buttons);
    }
  }

  // onBodyClick(event)
  // {
  //   if(!hasParentClass(event.target, 'compare-panel')) {
  //     this.closePanel();
  //   }
  // }
}
